// @flow
import React from "react";
import * as firebaseui from "firebaseui";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "firebase/app";
import AppHeader from "../components/AppHeader";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import { AuthCheck, useAnalytics } from "reactfire";
import Helmet from "react-helmet";

function Login() {
  const analytics = useAnalytics();

  const uiConfig = {
    signInOptions: [
      {
        provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        clientId:
          "768105548201-mln37lo9ek6bpqkvt7cqjrgbpb7knps6.apps.googleusercontent.com",
      },
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        recaptchaParameters: {
          type: "image",
          size: "normal",
          badge: "inline",
        },
        defaultCountry: "DE",
      },
      {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: false,
      },
    ],
    signInFlow: "redirect",
    signInSuccessUrl: "/profile",
    // tosUrl: "/",
    // privacyPolicyUrl: "/",
    // autoUpgradeAnonymousUsers: true,
    credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
    callbacks: {
      signInSuccessWithAuthResult: (authResult) => {
        const { additionalUserInfo } = authResult;
        if (additionalUserInfo == null) {
          return;
        }
        if (additionalUserInfo.isNewUser) {
          // its a sign up
          analytics.logEvent("sign_up", {
            method: additionalUserInfo.providerId,
          });
        } else {
          // its login
          analytics.logEvent("login", {
            method: additionalUserInfo.providerId,
          });
        }
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>Login - SG Coesfeld 06</title>
      </Helmet>
      <AuthCheck
        fallback={
          <>
            <AppHeader title={"Anmeldung"} />
            <Container maxWidth="sm">
              <Box mb={2}>
                <Typography color="textSecondary">
                  Melde dich an, um Tickets für die Heimspiele bequem und
                  einfach online zu reservieren.
                </Typography>
              </Box>
              <StyledFirebaseAuth
                uiConfig={uiConfig}
                firebaseAuth={firebase.auth()}
              />
            </Container>
          </>
        }
      >
        Du bist bereits angemeldet.
      </AuthCheck>
    </>
  );
}

export default Login;
